import { useSearch } from "@tanstack/react-router";

import { DEFAULT_KIT_ID } from "../utils/kits";

// Active brand kit for the current wizard URL. `strict: false` so the hook is
// safe anywhere (masthead, api hooks): outside a route with a `kit` search
// param it just resolves to the default kit.
export function useOnboardingKit(): string {
  const { kit } = useSearch({ strict: false });
  return kit ?? DEFAULT_KIT_ID;
}
